<div class="feature-section bg-lem-yellow-light p-3 rounded-3">
    <h2 class="fs-4 mb-4 fw-semibold text-center">Exclusiv für Lehrpersonen</h2>
    <div #features id="section-teacher-information" class="feature-list align-items-start d-flex gap-4 justify-content-center">
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'hsm-icon.png' | asset" alt="Feature Aufgaben-Manager" />
            <span><strong>Aufgaben-Manager</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'sidebar/test-generator.png' | asset" alt="Feature Schularbeiten- und Testgenerator" />
            <span><strong>Schularbeiten- und Testgenerator</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'sidebar/sidebar-icon-calcuflow.png' | asset" alt="Feature Arbeitsblätter" />
            <span><strong>Arbeitsblätter</strong><br />aus Aufgaben erstellen</span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'solution-icon.png' | asset" alt="Feature Lösungen" />
            <span><strong>Lösungen</strong><br />zu Aufgaben und Hausübungen</span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'welcome/icon-pdf-download.png' | asset" alt="Feature PDF-Download" />
            <span><strong>PDF-Download</strong><br />(ganzes PDF)</span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'topbar-icon-materialien.png' | asset" alt="Feature Gratis-Materialien" />
            <span><strong>Gratis-Materialien</strong><br />Jahresplanungen, Serviceteile und mehr</span>
        </div>
    </div>
</div>